import React, { Suspense } from "react";
import { useState } from "react";

import { useTranslate } from "../../../../i18n/useTranslationModules";
import { useTypedSelector } from "../../../../store/reducers/use-typed-selector";
import { Session, SessionTypesEnum, } from "../../../../types/working-model";
import { Button } from "../../../general-ui/button/button";
const FiresideModal = React.lazy(() => import("./fireside-modal"));

interface IHostControlsProps {
	session: Session;
	template: string;
	admin?: boolean;
}

const HostControls = ({ session, template, admin = false }: IHostControlsProps): JSX.Element => {
	const firesidesHostSessions: number[] = useTypedSelector(state => state.LiveEventReducer.firesidesHostSessions);
	const hasActiveStream = useTypedSelector(state => state.FiresidesReducer.hasActiveStream);

	const { t } = useTranslate("session");

	const [joinModalOpen, setJoinModalOpen] = useState<boolean>(false);

	// only return this component for fireside sessions - always show for admin, only show for live if attendee has host privileges
	if (session?.session_type !== SessionTypesEnum.fireside || (!admin && !firesidesHostSessions.includes(session.session))) return (<></>);

	// join 15 minutes (900000 milliseconds) before start of session until 15 after end of session
	const allowJoin: boolean = (
		(
			!!session.timestamp
			&& !!session.end_timestamp
			&& (session.timestamp - 3600000) < Date.now()
			&& (session.end_timestamp + 900000) > Date.now()
		)
		// or if there's someone in the stream
		|| hasActiveStream
	);

	const handleJoin = () => {
		window.location.href = `${window.location.href}/fireside`;
	};

	return (
		<div className="host-control-container">
			<Button classButton={"primary"} template={template} isDisabled={!allowJoin} onClick={setJoinModalOpen}>
				{t("Join Stage")}
			</Button>

			<Suspense fallback="">
				{joinModalOpen && <FiresideModal
					template={template}
					session={session}
					onCancelClicked={() => setJoinModalOpen(false)}
					onConfirmClicked={handleJoin}
					isOpen={joinModalOpen}
					close={() => setJoinModalOpen(false)}
				/>}
			</Suspense>
		</div>
	);
};

export default HostControls;
